import { FC } from 'react';
import { formatAmount } from 'utils/amountUtils';
import { getInitials } from 'utils/commonUtils';
import DateUtils from 'utils/dateUtils';
import { CaretRightIcon } from 'assets/icons';
import CustomAvatar from 'components/avatar/CustomAvatar';
import { IInvoice, InvoiceStatus } from '../invoices.model';
import { getInvoiceStatus, getInvoiceStatusColor, getPendingDays } from '../utils';
interface InvoiceCardProps {
  data: IInvoice;
  currencySymbol?: string;
  onInvoiceClick: (invoiceId: string) => void;
}

const InvoiceCard: FC<InvoiceCardProps> = props => {
  const { data, currencySymbol = '$', onInvoiceClick } = props;

  const getInvoiceStatusText = () => {
    if (data.status === InvoiceStatus.PENDING) {
      return getPendingDays(data.createdAt);
    }
    return getInvoiceStatus(data.status);
  };

  const getDate = () => {
    const date = DateUtils.getDateInFormat({ date: new Date(data.createdAt), dateFormat: 'dd MMM yyyy' });
    return date;
  };

  return (
    <div
      id="invoice-details-card-click"
      className="flex cursor-pointer items-center justify-between pb-3"
      onClick={() => onInvoiceClick(data.invoiceId)}>
      <div className="flex flex-col gap-1">
        <div className="text-17px font-semibold tracking-[-0.3px] text-primaryText">{data.invoiceNumber}</div>
        <div className="flex items-center gap-2">
          <div className="text-px13 leading-[17px] text-accentText">{getDate()}</div>
          <div className="h-1 w-1 rounded-full bg-accentText" />
          <CustomAvatar
            src={data.merchantProfilePicureUrl}
            label={getInitials(data.merchantName)}
            width="w-4"
            height="h-4"
            fontStyle="text-[9px]"
          />
        </div>
      </div>
      <div className="flex items-center gap-2 text-right">
        <div className="flex flex-col gap-1">
          <div className="text-17px font-bold tracking-[0-.3px] text-primaryText">
            {currencySymbol}
            {formatAmount(data.amount)}
          </div>
          <div
            className="text-px13 leading-[17px]"
            style={{ color: getInvoiceStatusColor(data.status as InvoiceStatus) }}>
            {getInvoiceStatusText()}
          </div>
        </div>
        <div className="cursor-pointer">
          <CaretRightIcon className="path-fill-current text-gray-1" />
        </div>
      </div>
    </div>
  );
};

export default InvoiceCard;
